import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import styles from "./CreditsDialog.module.scss";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CreditsDialog = ({ open, handleClose }) => {
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={() => handleClose}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle className={styles.creditsTitle}>Credits</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          <a
            href="https://www.flaticon.com/free-icons/cursor"
            title="cursor icons"
            target={"_blank"}
            rel="noreferrer"
            className={styles.creditsLink}
          >
            Cursor icons created by Freepik - Flaticon
          </a>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreditsDialog;
